import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useToast } from '@naf-simba/elements-toast';
import useSelector from '../redux/typedHooks';

export const useOpenInCms = () => {
  const location = useLocation();
  const slug = location.pathname.split('/').pop();
  const category = useSelector((state) => (slug ? state.sitestructure.mappedCategories[slug]?.data : undefined));
  const document = useSelector((state) => (slug ? state.documents.mappedData[slug]?.data : undefined));
  const isEditor = useSelector((state) => state.application.isEditor);
  const cmsEnv = useSelector((state) => state.application.cmsEnv);

  const { enqueueToast } = useToast();

  useEffect(() => {
    if (category && isEditor && cmsEnv) {
      enqueueToast(category.name, {
        key: category.id || undefined,
        preventDuplicate: true,
        variant: 'info',
        persist: true,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        onClick: () => {
          window.open(`${cmsEnv}/nafno/desk/__edit__${category.id}%2Ctype%3DnafnoSiteStructure`);
        },
      });
    }
    if (document && isEditor && cmsEnv) {
      enqueueToast(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document?.name || document?.title,
        {
          key: document.id || undefined,
          preventDuplicate: true,
          variant: 'info',
          persist: true,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          onClick: () => {
            if (document.id && document.type) {
              window.open(`${cmsEnv}/nafno/desk/__edit__${document.id}%2Ctype%3D${document.type}`);
            }
          },
        },
      );
    }
  }, [category, document, isEditor, cmsEnv, enqueueToast]);
};
